

//Ссылка
export default function Link({s, v}) {
	if(!v) return null;
	return (
        <a 
			href={v}
			target="_blank"
			style={{lineHeight: '40px'}}
		>
			{s.label}
		</a>
    )
}